// extracted by mini-css-extract-plugin
export default {"centered":"NpcDialogueManager_centered__Msks3","responsesWrapper":"NpcDialogueManager_responsesWrapper__4p9py","response":"NpcDialogueManager_response__FSsYg"};